import { fetcher } from '@commenda/utils';
import { UpdateSecureInformationRequestArgs } from './types';

export async function updateSecureInformationRequest(
  secureInformationRequestId: string,
  body: UpdateSecureInformationRequestArgs,
  token?: string
) {
  const response = await fetcher(
    `secureInformationRequest/${secureInformationRequestId}`,
    {
      method: 'POST',
      body,
    },
    token
  );

  return response;
}
